(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["register"]) return;
  try {
    
  <!-- basic spam protection bc we disabled shopify's captcha -->
  var honeyPot = document.getElementById('stickySubstance');
  var submitBtn = document.getElementById('submitRegistration');
  var checkDisableForm = function() {
    if (honeyPot.checked == true) {
      submitBtn.setAttribute("disabled", "disabled");
    } else {
      submitBtn.removeAttribute("disabled");
    }
  }
  honeyPot.addEventListener('click', checkDisableForm);

  } catch(e) { console.error(e); }
})();
})();
